import { useEffect, useState } from 'react';
import { sendMessageIcon } from '../../assets';
import './index.css';
import SocketStore from '../../stores/SocketStore';
import strings from '../../localization';

export const MessageInput = ({ size, onSend, role }) => {
  const [message, setMessage] = useState('');
  const [isTyping, setIsTyping] = useState(false);

  useEffect(() => {
    if (message.length > 0 && !isTyping) {
      if (role === 'customer') {
        SocketStore.sendCustomerTyping(true);
      } else {
        SocketStore.sendTechTyping(true);
      }
      setIsTyping(true);
    }

    if (message.length === 0 && isTyping) {
      if (role === 'customer') {
        SocketStore.sendCustomerTyping(false);
      } else {
        SocketStore.sendTechTyping(false);
      }
      setIsTyping(false);
    }

  }, [message]);

  return (
    <div className={`message-input-container ${size === 'small' ? 'message-input-container-small' : ''}`}>
      <input type="text" placeholder={strings.enterYourMessage} value={message} onChange={(e) => setMessage(e.target.value)} onKeyDown={(e) => {
        if (e.key === 'Enter') {
          onSend(message);
          setMessage('');
        }
      }} />
      <button onClick={(e) => {
        onSend(message);
        setMessage('');
      }}><img src={sendMessageIcon} alt="send message" /></button>
    </div>
  );
};